<template>
<m-pageframe
    title="Bulk Contact Changes: {organization-label}"
>
<v-container
    fluid
>
    <link-back
        text="All Contacts"
        :to="{
            name: 'fulltext-search-contacts',
            params: { organization_id: $route.params.organization_id }
        }"
    />

    <v-alert
        type="info"
        class="mt-2 mb-4"
        border="left"
        colored-border
        dismissible
        text
        dense
    >
        Made a mess of your contacts? You can reverse bulk changes by clicking "Reverse changes..." on the details page of each bulk change entry.
    </v-alert>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="clickable-rows elevation-1"
        :hide-default-footer="true"
        :loading="loading"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        @click:row="onClickViewChange"
    >
    
        <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickViewChange(item)"
                >
                    <v-list-item-title>View details...</v-list-item-title>
                </v-list-item>
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            loading: false,
            full_text: null,
            results: [],

            headers: [
                { text: 'Date', value: 'time_date'},
                { text: 'Time', value: 'time_time'},
                { text: 'Type', value: 'type'},
                { text: 'Label', value: 'label'},
                { text: 'Created', value: 'count_created'},
                { text: 'Modified', value: 'count_modified'},
                { text: 'Delete', value: 'count_deleted'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.loading = true;
            
            this.$rc.rest({
                spinner: false,
                endpoint: 'LIST: /api/v1/contacts/savepoint',
            
                params : {
                    organization_id: this.$route.params.organization_id,
                    full_text: this.full_text,
                },
            
                on_success: (data) => {
                    this.results = data.results;
                    this.loading = false;
                },
            
                on_error: (error) => {
                    this.loading = false;
                    this.$rc.alert('Error', 'Unable to search bulk contact changes');
                },
            });
        },

        onClickViewChange(item)
        {
            this.$router.push({
                'name': 'search-bulk-contact-change-entries',
                'params' : {
                    'organization_id': item.organization_id,
                    'savepoint_id': item.savepoint_id,
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>